<button class="reports-window-button rp-button rp-primary rp-outlined" (click)="toggleOpenWindow(true)" *ngIf="showButton$ | async">
  Ver reportes
</button>
<div class="reports-window-container" *ngIf="open$ | async">
  <div class="reports-window">
    <div class="reports-window-header">
      <div class="reports-window-title">
        <p class="f-body-1 semi-bold">{{ "REPORTS_WINDOW.TITLE" | translate }}</p>
        <p class="f-caption-2 rp-gray-12">{{ "REPORTS_WINDOW.SUBTITLE" | translate }}</p>
      </div>
      <div>
        <button (click)="refreshOrders()" class="refresh-btn">
          <img src="assets/icons/svg/reload.svg" height="20px" alt="refresh" />
        </button>
      </div>
    </div>
    <div class="reports-window-content">
      <div class="report" *ngFor="let report of reports$ | async">
        <div class="info">
          <p class="f-body-1 semi-bold">{{ "REPORTS.TYPE." + report.type | translate }}</p>
          <p class="f-caption-2">{{ report.created_at | cargoDate }}</p>
          <a class="open-report" *ngIf="report.location" [href]="report.location">{{ "abre reporte" }}</a>
        </div>
        <div class="status">
          <p [ngClass]="['report-status', report.status | lowercase]">
            {{ "REPORTS.STATUS." + report.status | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div (click)="toggleOpenWindow(false)" class="reports-window-backdrop"></div>
</div>
